import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const PriPrimarySchool = () => {
     useEffect(() => {
        document.title = 'Pre Primary School -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li>  
     <li>Pre Primary School </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Pre-Primary School  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <h3>Foundational Stage (Pre-Primary & Class I - II)</h3>
       <p>The Foundational Stage focuses on nurturing the curiosity and creativity inherent in young learners. At this stage, we aim to build a strong foundation in language development, particularly in reading, writing, and speaking, while fostering social and emotional development. Through play-based learning, children engage in hands-on activities that stimulate their imagination and encourage critical thinking and problem-solving.</p>
       <p><b>Key Areas of Focus:</b></p>
       <ul className="list">
       <li><b> Language skills:</b> Phonics, storytelling, and language games to enhance vocabulary and communication. We promote multilingualism by introducing students to different languages early, supporting their ability to communicate across cultures.
       </li>
       <li><b> Numeracy:</b> Fun, hands-on activities to introduce basic concepts like counting, patterns, and shapes.
       </li>
       <li><b> Physical development:</b> Introducing sports activities such as simple games, running, and group activities that develop coordination, motor skills, and teamwork.
       </li>
       <li><b> Emotional intelligence:</b> Activities that help children recognize and express their emotions, build empathy, and interact positively with peers.
       </li>
       <li><b> Art-integrated learning:</b> Students engage in creative activities that blend learning with artistic expression, enhancing their cognitive and emotional development.
       </li>
       </ul>
       <p><b>Learning Outcomes:</b></p>
       <ul className="list">
       <li><b> Language: </b> Basic vocabulary, understanding simple instructions, and expressing thoughts in multiple languages.
       </li>
       <li><b> Physical Development: </b> Enhanced coordination, motor skills, and teamwork through structured play and sports activities.
       </li>
       <li><b> Social-Emotional Skills: </b> Improved emotional recognition, empathy, and social interactions with peers. </li>
       </ul>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default PriPrimarySchool
